import { render, staticRenderFns } from "./ActivityItemNew.vue?vue&type=template&id=562bbcde&scoped=true"
import script from "./ActivityItemNew.vue?vue&type=script&lang=ts"
export * from "./ActivityItemNew.vue?vue&type=script&lang=ts"
import style0 from "./ActivityItemNew.vue?vue&type=style&index=0&id=562bbcde&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562bbcde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('562bbcde')) {
      api.createRecord('562bbcde', component.options)
    } else {
      api.reload('562bbcde', component.options)
    }
    module.hot.accept("./ActivityItemNew.vue?vue&type=template&id=562bbcde&scoped=true", function () {
      api.rerender('562bbcde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/ActivityItemNew.vue"
export default component.exports